import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { LeftOutlined, SearchOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { getGradientById } from '../../utils/color'

import '../../components/PlaylistSection.scss'
import './Styles.scss'
import SearchInput from '../../components/SearchInput/SearchInput'

type DemoStyle = {
  _id: string
  title: string
  image: string
}

const PHOTO =
  'https://img.freepik.com/free-photo/still-life-wireless-cyberpunk-headphones_23-2151072227.jpg?semt=ais_user_personalization&w=740&q=80'

const demoStyles: DemoStyle[] = [
  { _id: 'kpop', title: 'Kpop', image: PHOTO },
  { _id: 'rnb', title: 'R&B', image: PHOTO },
  { _id: 'pop', title: 'Pop', image: PHOTO },
  { _id: 'indie', title: 'Indie', image: PHOTO },
  { _id: 'folk', title: 'Folk', image: PHOTO },
  { _id: 'jazz', title: 'Jazz', image: PHOTO },
  { _id: 'rock', title: 'Rock', image: PHOTO },
  { _id: 'edm', title: 'EDM', image: PHOTO },
  { _id: 'rap', title: 'Rap', image: PHOTO },
  { _id: 'lofi', title: 'Lo-Fi', image: PHOTO },
  { _id: 'house', title: 'House', image: PHOTO },
  { _id: 'latin', title: 'Latin', image: PHOTO },
]

export default function Styles() {
  const navigate = useNavigate()
  const { i18n } = useTranslation()

  const [isMobile, setIsMobile] = useState(false)
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 900px)')
    const onChange = () => setIsMobile(mq.matches)
    onChange()
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [])

  const [search, setSearch] = useState('')

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase()
    if (!q) return demoStyles
    return demoStyles.filter((it) => it.title.toLowerCase().includes(q))
  }, [search, i18n.language])

  return (
    <div
      className="st"
      style={
        {
          ['--st-bg' as any]: `url(${PHOTO})`,
          ['--st-avatar' as any]: `url(${PHOTO})`,
        } as React.CSSProperties
      }
    >
      {/* DESKTOP TOP SEARCH: только твой кастомный SearchInput */}
      {!isMobile && (
        <div className="st-top">
          {/* Если твой SearchInput умеет value/onChange — оставь так */}
          <SearchInput
            value={search}
            onChange={(v: any) =>
              setSearch(typeof v === 'string' ? v : (v?.target?.value ?? ''))
            }
          />
        </div>
      )}

      {/* mt-[100px] -> делаем через style={{}} */}
      <div className="st-wrap" style={{ marginTop: isMobile ? 0 : 100 }}>
        {/* DESKTOP HEADER (как на фото) */}
        {!isMobile && (
          <div className="st-head">
            <button
              type="button"
              className="st-back"
              onClick={() => navigate(-1)}
              aria-label="Back"
            >
              <LeftOutlined />
            </button>

            <div className="st-headText">
              <div className="st-avatar" aria-hidden="true" />

              <div className="st-titleRow">
                <div className="st-overline">CHOOSE YOUR STYLE</div>
                <div className="st-title">Styles</div>
              </div>
            </div>
          </div>
        )}

        {/* MOBILE HERO оставляю как было (пока), фон тоже та же фотка */}
        {isMobile && (
          <div className="st-hero">
            <div className="st-heroTop">
              <button
                type="button"
                className="st-heroBtn"
                onClick={() => navigate(-1)}
                aria-label="Back"
              >
                <LeftOutlined />
              </button>

              <button type="button" className="st-heroBtn" aria-label="Search">
                <SearchOutlined />
              </button>
            </div>

            <div className="st-heroArt" aria-hidden="true" />

            <div className="st-heroText">
              <div className="st-heroTitle">Styles</div>
              <div className="st-heroSub">Choose your style</div>
            </div>
          </div>
        )}

        <section className="ps ps--tiles">
          <div className="st-grid" aria-label="Styles grid">
            {filtered.map((item) => {
              const id = String(item._id ?? item.title)
              const grad = getGradientById(id, 'style')

              return (
                <button
                  key={id}
                  type="button"
                  className="ps-tile"
                  onClick={() => navigate(`/category/style/${id}`)}
                  title={item.title}
                  style={
                    {
                      ['--tile-a' as any]: grad.a,
                      ['--tile-b' as any]: grad.b,
                    } as React.CSSProperties
                  }
                >
                  <div className="ps-tile__label">{item.title}</div>
                  <div className="ps-tile__artWrap">
                    <img className="ps-tile__art" src={item.image} alt={item.title} />
                  </div>
                </button>
              )
            })}
          </div>
        </section>
      </div>
    </div>
  )
}
